module.exports = __webpack_public_path__ + "img/icon_dean_home_bg_card_6.596997e3.png";